<app-allergens
  [food]="food"
  [allergens]="allergens"
  [restaurant]="restaurant"
  class="h-100"
>
</app-allergens>
